module.exports = __webpack_public_path__ + "img/logbookbutton.146889ef.png";